<script setup lang="ts"></script>

<template>
  <Home1Title />
  <Home2Vision />
  <Home3TopProjects />
  <Home4AlwaysRelevant />
  <Home5VisionBlog />
  <Home6Faq />
</template>

<style scoped></style>
